export default __webpack_public_path__ + "static/media/bg.de1f4ddb.png";